import * as React from "react";
const SvgFiRrExpandArrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-expand-arrows_svg__a)">
      <path d="M22.978 9.022a1 1 0 0 0 1-1V3.978a4 4 0 0 0-4-4h-4a1 1 0 1 0 0 2h4q.278.003.545.085L12 10.585 3.478 2.064q.235-.062.477-.064H8a1 1 0 0 0 0-2H3.955a4 4 0 0 0-4 4v4a1 1 0 0 0 2 0V4q.004-.28.085-.546l8.546 8.545-8.55 8.551a2 2 0 0 1-.08-.529v-4.044a1 1 0 0 0-2 0v4.044a4 4 0 0 0 4 4h4a1 1 0 1 0 0-2h-4a2 2 0 0 1-.495-.069l8.54-8.538 8.505 8.506c-.171.05-.35.077-.528.08h-4.045a1 1 0 0 0 0 2h4.045a4 4 0 0 0 4-4v-4a1 1 0 0 0-2 0v4a2 2 0 0 1-.07.494L13.414 12l8.5-8.5q.06.235.064.478v4.044a1 1 0 0 0 1 1" />
      <path d="M23 9a1 1 0 0 0 1-1V3a3 3 0 0 0-3-3h-5a1 1 0 1 0 0 2h4.586L12 10.586 3.414 2H8a1 1 0 0 0 0-2H3a3 3 0 0 0-3 3v5a1 1 0 0 0 2 0V3.414L10.586 12 2 20.586V16a1 1 0 1 0-2 0v5a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2H3.414L12 13.414 20.586 22H16a1 1 0 0 0 0 2h5a3 3 0 0 0 3-3v-5a1 1 0 0 0-2 0v4.586L13.414 12 22 3.413V8a1 1 0 0 0 1 1" />
    </g>
    <defs>
      <clipPath id="fi-rr-expand-arrows_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExpandArrows;
